<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
    <g fill="none" fill-rule="evenodd">
        <g fill="#2490FF">
            <g>
                <g>
                    <g>
                        <path d="M17.174 6.5L19 8.441 10.49 17.5 5 11.676 6.826 9.735 10.49 13.618z" transform="translate(-830 -271) translate(782 193) translate(48 32) translate(0 46)"/>
                    </g>
                </g>
            </g>
        </g>
    </g>
</svg>
